__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-host/19744766111/";